
import shareImg from '../../../static/images/share.png';
import topbag from './images/topbag.png';
import gzherCodeImg from '../../../static/images/wx.jpg';
import jt from './images/jt.png';
import axios from 'axios';
import wx from 'weixin-js-sdk';
import $ from 'jquery';
import {chinamobile,SFZnumber} from '@/api/validate';
import {urlConfig} from '@/api/urlConfig';
import {promptMessage,fetch,baseUrl} from '@/api/dataHandling';
import {getken} from '@/api/getToken';
import Checker from 'vux/src/components/checker/checker.vue'
import CheckerItem from 'vux/src/components/checker/checker-item.vue'
import CheckIcon from 'vux/src/components/check-icon/index.vue'
import Search from 'vux/src/components/search/index.vue'
import Toast from 'vux/src/components/toast/index.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import Qrcode from 'vux/src/components/qrcode/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Checklist from 'vux/src/components/checklist/index.vue'
import PopupRadio from 'vux/src/components/popup-radio/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Icon from 'vux/src/components/icon/index.vue'

export default {
data () {
return {
jt,
topbag,
shareImg,
gzherCodeImg,
guanzhuTxt:'',
guanzhushow:false,
createPostersShow:false,
xinanstaff:false,
showBack:true,
areaShow:false,
zdyChannelId:'',
phoneIcon:false,
nameIcon:false,
sexIcon:false,
preVisitTypeIcon:false,
userIdent:'',
hospitalShow:false,
doctorShow:false,
preExclusiveCheck:false,
pregnancyDurShow:false,
gonghao:'',
qrcodeUrl:'',
serviceType:'需指导到院',
mypoint:'',
SFZiconType:'',
hospitaldialogresults: [],
seachdialogresults:[],
doctordialogresults:[],
hospitaldialogvalue:'',
docAreaList:[],
anothhospitaldialog:false,
submitdisabled:false,
sexoptions: [{key: 1, value: '男'},{key: 2, value: '女'}],
vipConsultCkList: [{key: '1', value: '是'},{key: '2', value: '否'}],
belongAreaName:"",
hosCode:"",
pregistration:{
certNo:'',
phone:'',
name:''
},
basemessage:{
consultUser:"",
patientNeed:"",
pregnancyDur:"",
remark:"",
birthday: "",
certNo: "",
certType: "",
channelCardNo: "",
channelContact: "",
channelId: "",
channelInfoId: "",
channelOutDoctor: "",
channelOutDoctorId: "",
channelPhone: "",
hospitalId: "",
belongArea:"",
vipConsult:"",
id: "",
name: "",
phone: "",
registerType: "",
sex:2,
userId: "",
preVisitType:'',
},
chinamobile,
wexinlogo:'',
toastshow:false,
toastTxt:'',
fontTxt:'',
tabindex:0,
tabOption:['文字识别信息'],
zhezhaoshow:false,
sexTxt:'',
consultUseroptions:[],
firstVisitoptions: [],
certTypeoptions: [],
YYhospitaloptions: [],
saiYYhospitaloptions:[],
anothdoctoroptions:[],
patientNeedoptions:[],
}
},
directives: {
TransferDom
},
components: {
CheckIcon,Search,Checklist,Toast,Tab, TabItem,XDialog,Qrcode,XInput,PopupRadio,Cell,XTextarea, Group, XHeader,XButton,Icon, Checker, CheckerItem
},
methods:{
createPosters(){
this.$router.push({path:'activityPosterManage?personInfoId='+this.personInfoId+'&hosCode='+this.hosCode});
},
collectPosters(){
this.$router.push({path:'activityPosterDisplay?personInfoId='+this.personInfoId+'&hosCode='+this.hosCode});
},
isxinan(){
fetch('post',urlConfig.isStaff+this.personInfoId).then(response => {
if(response ==1){
this.xinanstaff = true
}
this.$store.commit('updateLoadingStatus',{isLoading:false});
}).catch(error => {

});
axios.defaults.headers.common['Authorization'] = window.localStorage.getItem('token')
axios.get(baseUrl + urlConfig.getzd+'728').then(response => {
let data = response.data;
for(let i=0;i<data.length;i++){
if(this.personInfoId == data[i].szdCmc.trim() && data[i].ssfyx== '1'){
this.createPostersShow =true;
}
}

this.$store.commit('updateLoadingStatus',{isLoading:false});
}).catch(error => {

})
},
xiezhu(){
window.localStorage.setItem('userIdent',this.userIdent);
window.localStorage.setItem('channelId',this.basemessage.channelId);
window.localStorage.setItem('userid',this.basemessage.userId);
this.$router.push({path:'/pregnancyPatientDetails?tabindex=2&title=协助他人登记&hosCode='+this.hosCode});
},
zizhudengji(){
$('.twopage').slideDown();
$('.onpage').slideUp();
},
hide(){
$('.twopage').show();
$('.onpage').hide();
this.showBack =false;
},
back(){
$('.twopage').slideUp();
$('.onpage').slideDown();
},
requiredMethod(){
console.log(arguments,33)
for(let i=0;i<arguments.length;i++){

if(arguments[i][0]){
if(arguments[i][0].toString().trim() == ''){
this[arguments[i][1]]= true;
}else{
this[arguments[i][1]]= false;
}
}else{
this[arguments[i][1]]= true;
}

}

}, //是否必填
IconClick(text){
this.toastshow = true;
this.toastTxt = text;
},
getopenid(code){
let cutton = 'http://front.wh.jinxin-fertility.com/pregnancyRegistration';
axios.get('http://front.wh.jinxin-fertility.com/weixin/getOpenIdByCode?code=' +  code+'&hosCode='+this.hosCode).then(response => {
if(response.data.resultCode == 'success'){
if(response.data.openid.trim() !=''){
this.openid = response.data.openid;

getken(this.getUserId);
}else{
let parmasquery = '?bb=1';
for(let i in this.$route.query){
if(i != 'code' && i != 'bb' ){
parmasquery = parmasquery +'&' + i + '=' + this.$route.query[i];

}
}
window.location.href = cutton+parmasquery+'&time='+((new Date()).getTime());
}
}else{
let parmasquery = '?bb=1';
for(let i in this.$route.query){
if(i != 'code' && i != 'bb' ){
parmasquery = parmasquery +'&' + i + '=' + this.$route.query[i];

}
}
window.location.href = cutton+parmasquery+'&time='+((new Date()).getTime());
}

}).catch(function (error) {
promptMessage('提示' +error)
this.submitdisabled = true;
this.$store.commit('updateLoadingStatus',{isLoading:true});

});
},
getUserId(){
this.getDicAreaList();
let _this = this;
/*       this.openid = 'oX8Cw5hQJiOW1bPSVeYRljdEBbzI';*/
/*    this.openid = 'oX8Cw5geHVtTBsJZU-Ud3gMOHYUM'; */
if(this.$route.query.ivfRegisterPosterHid){
this.hide();
this.basemessage.ivfRegisterPosterHid = this.$route.query.ivfRegisterPosterHid;
}
if(this.$route.query.activityId){
this.hide();
this.basemessage.activityId = this.$route.query.activityId;
}else{
this.basemessage.activityId = '';
}
if(this.$route.query.sfzh){   //如果是分享 或者 外院医生
this.hide();
if(window.localStorage.getItem('userid')){
this.basemessage.userId = window.localStorage.getItem('userid');
}
this.getPersonRole(this.$route.query.sfzh);

this.qrcodeUrl = location.href.substring(0,location.href.lastIndexOf('/')+1) + 'pregnancyRegistration?sfzh='+this.$route.query.sfzh+'&gz=1'

}else if(this.$route.query.channelIdent){   //如果公众号进入的
this.hide();
this.getQuDao();
promptMessage('提示','请完善信息后开启专家咨询');
if(this.$route.query.userId){  //有传播人
this.qrcodeUrl = location.href.substring(0,location.href.lastIndexOf('/')+1) + 'pregnancyRegistration?channelIdent='+ this.$route.query.channelIdent + '&userId=' + this.$route.query.userId+'&gz=1';
this.basemessage.userId = this.$route.query.userId;

}else{
this.qrcodeUrl = location.href.substring(0,location.href.lastIndexOf('/')+1) + 'pregnancyRegistration?channelIdent='+ this.$route.query.channelIdent+'&gz=1';
fetch('get',urlConfig.GetSfzh + '?openid='+this.openid).then(response => {
this.getpersoninfoId(response.sfzh)
}).catch(error => {

})
}

}else{
fetch('get',urlConfig.GetSfzh + '?openid='+this.openid).then(response => {
this.getPersonRole(response.sfzh);
this.qrcodeUrl = location.href.substring(0,location.href.lastIndexOf('/')+1) + 'pregnancyRegistration?sfzh='+ response.sfzh+'&gz=1'
this.getpersoninfoId(response.sfzh)
}).catch(error => {
this.submitdisabled = true;
promptMessage('提示','未获取到登记人信息，请关闭页面重新打开！')

})
}
this.getType();
wx.ready(function(){
wx.hideMenuItems({
menuList: ['menuItem:share:qq','menuItem:share:QZone','menuItem:copyUrl','menuItem:openWithSafari','menuItem:share:weiboApp'], // 要隐藏的菜单项，只能隐藏“传播类”和“保护类”按钮，所有menu项见附录3
});

wx.onMenuShareTimeline({
title: "助孕登记页面", // 分享标题
link: _this.qrcodeUrl,
imgUrl: _this.wexinlogo,
success: function () {

promptMessage('提示',"分享成功");
}
});

wx.onMenuShareAppMessage({
title: "助孕登记页面", // 分享标题
desc: '以爱之名，从心出发', // 分享描述
link: _this.qrcodeUrl,
imgUrl: _this.wexinlogo,
success: function () {

promptMessage('提示',"分享成功");

}
});
})

},
patientNeedChange(){
if(this.basemessage.patientNeed == '1'){
this.pregnancyDurShow = true;

}else{
this.pregnancyDurShow = false;
this.basemessage.pregnancyDur = '';
}
},   //患者需求
getQuDao(){
this.$store.commit('updateLoadingStatus',{isLoading:true});
fetch('post',urlConfig.pregnancyRegistratQuDao,{channelIdent:this.$route.query.channelIdent}).then(response => {
this.basemessage.channelId = this.$route.query.channelIdent;
this.basemessage.channelCardNo = response.identCardMech;
this.basemessage.channelContact = response.name;
this.basemessage.channelInfoId = response.id;
this.basemessage.channelOutDoctor = response.outDocker;
this.basemessage.channelOutDoctorId = response.outDockerId;
this.basemessage.channelPhone = response.phone;
this.$store.commit('updateLoadingStatus',{isLoading:false});
}).catch(error => {
this.submitdisabled = true;
this.$store.commit('updateLoadingStatus',{isLoading:true});
})
},
getDicAreaList(){
this.$store.commit('updateLoadingStatus',{isLoading:true});
fetch('post',urlConfig.pregnancyQueryDicAreaList).then(response => {
this.docAreaList=response;
this.$store.commit('updateLoadingStatus',{isLoading:false});
}).catch(error => {
this.submitdisabled = true;
this.$store.commit('updateLoadingStatus',{isLoading:true});
})
},
getpersoninfoId(sfz){
this.$store.commit('updateLoadingStatus',{isLoading:true});
let _this = this;
fetch('post',urlConfig.GetPersonInfoId +'?sfzh='+sfz).then(response => {
_this.basemessage.userId = response.personInfoId;   
_this.personInfoId = response.personInfoId;
_this.isxinan();
_this.$store.commit('updateLoadingStatus',{isLoading:false});
}).catch(error => {
_this.submitdisabled = true;
_this.$store.commit('updateLoadingStatus',{isLoading:true});
})
},
getPersonRole(sfzh){
this.$store.commit('updateLoadingStatus',{isLoading:true});
this.userIdent = '';
fetch('post',urlConfig.pregnancyRegistratGetreferencePerson + '?cardNo='+sfzh).then(response => {
if(this.$route.query.btdj){
this.basemessage.channelId = this.$route.query.btdj;
}else{
this.basemessage.channelId = response.channelId;
}

this.gonghao = response.empNo;
if(response.empNo){   //是否能发短信
window.localStorage.setItem('empNo',1);
window.localStorage.setItem('userStatus',response.userStatus);
}else{
window.localStorage.setItem('empNo',2);
}
if(response.channelId == '5'){
if(response.userIdent == 'adviser'){  //医疗顾问
this.userIdent = 'adviser';
this.basemessage.channelInfoId = response.preRefInfos[0].id;
if(response.preRefInfos.length >= 1){

this.hospitaldialogresults = [];
this.dilogresults = response.preRefInfos;
for(let i =0;i<response.preRefInfos.length;i++){
if(this.hospitaldialogresults.indexOf(response.preRefInfos[i].identCardMech) == -1){
this.hospitaldialogresults.push(response.preRefInfos[i].identCardMech);
}
}
}else if(response.preRefInfos.length<1){
promptMessage('提示','该医疗顾问在HIS系统中没有维护个人信息，请联系医院信息科处理');
this.submitdisabled = true;
}
}else{   //外院医生
if(response.preRefInfos.length >1){
promptMessage('提示','该医生在HIS系统中存在多条个人信息，请联系医院信息科处理');
this.submitdisabled = true;
}else if(response.preRefInfos.length <1){
promptMessage('提示','该医生在HIS系统中没有维护个人信息，请联系医院信息科处理');
this.submitdisabled = true;
}else {
this.basemessage.channelCardNo = response.preRefInfos[0].identCardMech;
this.basemessage.channelContact = response.preRefInfos[0].name;
this.basemessage.channelInfoId = response.preRefInfos[0].id;
this.basemessage.channelOutDoctor = response.preRefInfos[0].outDocker;
this.basemessage.channelOutDoctorId = response.preRefInfos[0].outDockerId;
this.basemessage.channelPhone = response.preRefInfos[0].phone;
promptMessage('提示','请完善信息后开启专家咨询');
}
}
}else{
if(response.preRefInfos.length >1){
promptMessage('提示','该身份在HIS系统中存在多条个人信息，请联系医院信息科处理');
this.submitdisabled = true;
}else if(response.preRefInfos.length <1){
promptMessage('提示','该身份在HIS系统中没有维护个人信息，请联系医院信息科处理');
this.submitdisabled = true;
}else {
this.basemessage.channelCardNo = response.preRefInfos[0].identCardMech;
this.basemessage.channelContact = response.preRefInfos[0].name;
this.basemessage.channelInfoId = response.preRefInfos[0].id;
this.basemessage.channelOutDoctor = response.preRefInfos[0].outDocker;
this.basemessage.channelOutDoctorId = response.preRefInfos[0].outDockerId;
this.basemessage.channelPhone = response.preRefInfos[0].phone;
}
}
this.$store.commit('updateLoadingStatus',{isLoading:false});
}).catch(error => {
this.submitdisabled = true;
this.$store.commit('updateLoadingStatus',{isLoading:true});
})
},  //获取角色
getType(){
let _this = this;
fetch('post',urlConfig.pregnancyRegistratGetType).then(response => {
_this.certTypeoptions = response.certType;  
for(let i=0;i<response.certType.length;i++){
_this.certTypeoptions[i]['key'] = response.certType[i].certCode;
_this.certTypeoptions[i]['value'] = response.certType[i].certName;
}
window.localStorage.setItem('certTypeoptions',JSON.stringify(_this.certTypeoptions));
_this.YYhospitaloptions = response.hospitals;
for(let i=0;i<response.hospitals.length;i++){
_this.YYhospitaloptions[i]['key'] = response.hospitals[i].id;
_this.YYhospitaloptions[i]['value'] = response.hospitals[i].deptmentName;
}
_this.firstVisitoptions = response.pubFirstVisit;
for(let i=0;i<response.pubFirstVisit.length;i++){
_this.firstVisitoptions[i]['key'] = response.pubFirstVisit[i].code;
_this.firstVisitoptions[i]['value'] = response.pubFirstVisit[i].name;
if(response.pubFirstVisit[i].sort == 1){
_this.basemessage.preVisitType = response.pubFirstVisit[i].code;
_this.sexTxt = '女方';
_this.basemessage.sex = 2;
}
}
_this.$store.commit('updateLoadingStatus',{isLoading:false});
}).catch(error => {
_this.submitdisabled = true;
_this.$store.commit('updateLoadingStatus',{isLoading:true});
});
fetch('get',urlConfig.getadall+'252').then(response => {
console.log(response,44443333)
_this.consultUseroptions = response;  
for(let i=0;i<response.length;i++){
_this.consultUseroptions[i]['key'] = response[i].remarkMeaning;
_this.consultUseroptions[i]['value'] = response[i].szdEbm;
}
_this.$store.commit('updateLoadingStatus',{isLoading:false});
}).catch(error => {
_this.submitdisabled = true;
_this.$store.commit('updateLoadingStatus',{isLoading:true});
})
axios.defaults.headers.common['Authorization'] = window.localStorage.getItem('token');
axios.get(baseUrl + urlConfig.getIVF+'/9977').then(response => {
_this.patientNeedoptions = response.data.data;
for(let i=0;i<response.data.data.length;i++) {
_this.patientNeedoptions[i]['key'] = response.data.data[i].sZdDm;
_this.patientNeedoptions[i]['value'] = response.data.data[i].sZdCmc;
}
}).catch(error => {

})


},

anothdoctorClick(obj){
if(obj == 'hospital'){  //选择转诊院区
this.hospitalShow = true;
this.doctorShow = false;
this.areaShow = false;
this.seachdialogresults = this.hospitaldialogresults;
this.anothhospitaldialog = true;
} else if(obj=='doctor') {  //选择医生
if(this.basemessage.channelCardNo){
this.hospitalShow = false;
this.areaShow = false;
this.seachdialogresults = this.doctordialogresults;
this.doctorShow = true;
this.anothhospitaldialog = true;
}else{
promptMessage('提示','请先选择转诊院区！')
}

}else{//选择片区
if(this.basemessage.channelOutDoctor){
this.hospitalShow = false;
this.doctorShow = false;
let tempList1=[];
let tempList2=[];
this.docAreaList.forEach(elment=>{
if(this.basemessage.channelId ==elment.remark){
tempList1.push({key:elment.dictCode,value:elment.dictName})
}else{
tempList2.push({key:elment.dictCode,value:elment.dictName})
}
});
console.log("channelid="+this.basemessage.channelId)
if(tempList1.length>0){
this.seachdialogresults = tempList1;
}else{
this.seachdialogresults = tempList2;
}
this.areaShow = true;
this.anothhospitaldialog = true;
}else{
promptMessage('提示','请先选择转诊医生！')
}

}
},
fuzhi(obj){

this.pregistration[obj] = this.basemessage[obj];
window.localStorage.setItem('pregistrationTxt',JSON.stringify(this.pregistration));
this.requiredMethod(
[this.basemessage[obj], obj+'Icon'],
);
},
hospitaldialogResult(val){

if(this.hospitalShow){

if(val.trim() != ''){
this.seachdialogresults =[];
for (let i = 0; i < this.hospitaldialogresults.length; i++) {
if (this.hospitaldialogresults[i].toString().indexOf(val) != -1) {
this.seachdialogresults.push(this.hospitaldialogresults[i])
}
}
}else{
this.seachdialogresults = this.hospitaldialogresults;
}
}
if(this.doctorShow){
if(val.trim() != ''){
this.seachdialogresults =[];
for (let i = 0; i < this.doctordialogresults.length; i++) {
if (this.doctordialogresults[i].outDocker.toString().indexOf(val) != -1) {
this.seachdialogresults.push(this.doctordialogresults[i])
}
}
}else{
this.seachdialogresults = this.doctordialogresults;
}
}
}, //转诊搜索
tuijianhuanzhe(){
window.localStorage.setItem('userid',this.basemessage.userId);
this.$router.push({path:'/pregnancyPatientDetails'});

},
dialogresultClick(item){
this.anothhospitaldialog = false;
this.hospitaldialogvalue = '';
if(this.hospitalShow){

this.basemessage.channelOutDoctor = '';
this.basemessage.channelCardNo = item;
this.doctordialogresults = [];
for(let i=0;i<this.dilogresults.length;i++){
if(item == this.dilogresults[i].identCardMech){
this.doctordialogresults.push(this.dilogresults[i]);
}
}
}
if(this.doctorShow){

this.basemessage.channelContact = item.name;
this.basemessage.channelInfoId = item.id;
this.basemessage.channelOutDoctor = item.outDocker;
this.basemessage.channelOutDoctorId = item.outDockerId;
this.basemessage.channelPhone = item.phone;
this.basemessage.belongArea=null;
this.belongAreaName=null;
if(item.outDockerTypeCode == '14'){
this.basemessage.channelId = '14';
}else{
this.basemessage.channelId = '5';
}
}
if(this.areaShow){
this.basemessage.belongArea=item.key;
this.belongAreaName=item.value;
}

},
firstVisitChange(){
this.saiYYhospitaloptions = [];
for(let i=0;i<this.firstVisitoptions.length;i++){
if(this.basemessage.preVisitType == this.firstVisitoptions[i].code){
if(this.firstVisitoptions[i].ident == '1'){
this.sexTxt = '男方';
this.basemessage.sex = 1;
}else if(this.firstVisitoptions[i].ident == '2'){
this.sexTxt = '女方';
this.basemessage.sex = 2;
}else{
this.sexTxt = '';
this.basemessage.sex = 9;
}
}
}
for(let j = 0;j<this.YYhospitaloptions.length;j++){
let yyvisitIdent = this.YYhospitaloptions[j]['visitIdent'].split(',');
for(let z=0;z<yyvisitIdent.length;z++){
if(this.basemessage.preVisitType == yyvisitIdent[z]){
this.saiYYhospitaloptions.push(this.YYhospitaloptions[j]);
}
}
}
},
tabItemClick(index){
this.tabIndex = index;
},
sureMothed(){
this.submitdisabled = true;
this.paramsDa = {};
for(let i in this.basemessage){
this.paramsDa[i] = this.basemessage[i];
}
if(this.zdyChannelId){
this.paramsDa.channelId = this.zdyChannelId;
}
fetch('post',urlConfig.pregnancyRegistratSubmit,this.paramsDa).then(response => {
window.localStorage.setItem('pregistrationTxt',null);
this.pregistration = {};

if(this.$route.query.ivfRegisterPosterHid || this.$route.query.gz=='1'){
this.guanzhushow = true;
this.guanzhuTxt = '登记成功！';
}else{
promptMessage('提示', '登记成功！');
}
this.submitdisabled = false;
}).catch(error => {
this.submitdisabled = false;
if(this.$route.query.ivfRegisterPosterHid || this.$route.query.gz=='1'){
this.guanzhushow = true;
this.guanzhuTxt = '';
}
})
},
submit(){
if(!this.preExclusiveCheck){  // 未勾选自行接待
this.basemessage.preExclusive = 2;
}else{
this.basemessage.preExclusive = 1;
}
console.log(this.basemessage,5555)
if(this.userIdent == 'adviser' && (this.basemessage.preVisitType == '01' || this.basemessage.preVisitType == '04')){
if(this.basemessage.channelCardNo && !this.basemessage.channelOutDoctor) {
promptMessage('提示', '请选择转诊医生！')
this.zdyChannelId = '';
return false;
}else if(this.basemessage.channelCardNo && this.basemessage.channelOutDoctor){
this.zdyChannelId = '';
}else{
this.zdyChannelId = this.basemessage.channelId ;
}
};
if(this.SFZiconType !='error' && chinamobile(this.basemessage.phone).valid && this.basemessage.preVisitType !='' && this.basemessage.name.trim() !='' && this.basemessage.sex !=''){
this.sureMothed();
/* if(this.basemessage.certNo !=''){  //还需要判断是不是身份证
if(this.basemessage.certType != ''){
let SFZSex = (this.basemessage.certNo.trim()).substring(this.basemessage.certNo.length-2,this.basemessage.certNo.length-1);
if(SFZSex%2 == 0) {  //女
this.basemessage.sex = 2;
}else{  //男
this.basemessage.sex = 1;
}   //sex赋值
if(this.basemessage.certNo.length==15){
this.basemessage.birthday = "19"+this.basemessage.certNo.substring(6,8)+"-"+this.basemessage.certNo.substring(8,10)+"-"+ this.basemessage.certNo.substring(10,12);
}
if(this.basemessage.certNo.length==18){
this.basemessage.birthday = this.basemessage.certNo.substring(6,10)+"-"+this.basemessage.certNo.substring(10,12)+"-"+ this.basemessage.certNo.substring(12,14);
}  //出生日期赋值
for(let i=0;i<this.firstVisitoptions.length;i++){
if(this.basemessage.preVisitType == this.firstVisitoptions[i].code){
if(this.firstVisitoptions[i].ident == '1' &&  SFZSex%2 != 0){  //通过 只能填男方信息验证

this.sureMothed();  

}else if(this.firstVisitoptions[i].ident == '2' &&  SFZSex%2 == 0){  //通过 只能填女方信息验证

this.sureMothed();  

}else if(this.firstVisitoptions[i].ident == '1,2'){  //通过 不论男女

this.sureMothed();  

}else{
promptMessage('提示','初诊类型与登记性别不符，请核实性别后再填写！');
}
}
}
}else{
promptMessage('提示','请选择证件类型！')
}

}else {  //没有录入身份证

if(this.basemessage.certType != ''){
promptMessage('提示','请输入证件号码！')
}else {

this.sureMothed();  
}
}*/

}else{
this.requiredMethod(
[this.basemessage.name, 'nameIcon'],
[this.basemessage.preVisitType, 'preVisitTypeIcon'],
[this.basemessage.phone, 'phoneIcon'],
[this.basemessage.sex, 'sexIcon'],
);
promptMessage('提示','还有选项未填写！')
}

console.log(this.basemessage,'提交')
},//提交
Sfzvalidate(){
this.basemessage.certNo = this.basemessage.certNo.trim();
this.pregistration.certNo = this.basemessage.certNo;
window.localStorage.setItem('pregistrationTxt',JSON.stringify(this.pregistration));
if(this.basemessage.certNo){
if(this.IdCodeValid(this.basemessage.certNo)){
this.SFZiconType = '';
}else{
this.SFZiconType = 'error';
}
}else{
this.SFZiconType = '';
}
}, //身份证验证
IdCodeValid(code){
let _this = this;
var city={11:"北京",12:"天津",13:"河北",14:"山西",15:"内蒙古",21:"辽宁",22:"吉林",23:"黑龙江 ",31:"上海",32:"江苏",33:"浙江",34:"安徽",35:"福建",36:"江西",37:"山东",41:"河南",42:"湖北 ",43:"湖南",44:"广东",45:"广西",46:"海南",50:"重庆",51:"四川",52:"贵州",53:"云南",54:"西藏 ",61:"陕西",62:"甘肃",63:"青海",64:"宁夏",65:"新疆",71:"台湾",81:"香港",82:"澳门",91:"国外 "};
var row = true;
if(!code || !/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|[X])$/.test(code)){
row=false;
_this.toastshow = true
_this.toastTxt = "证件号码有误";
}else if(!city[code.substr(0,2)]){
row=false;
_this.toastshow = true
_this.toastTxt = "证件号码有误,地址编码错误";
}else{

if(code.length == 18){
code = code.split('');
var factor = [ 7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2 ];

var parity = [ 1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2 ];
var sum = 0;
var ai = 0;
var wi = 0;
for (var i = 0; i < 17; i++)
{
ai = code[i];
wi = factor[i];
sum += ai * wi;
}
if(parity[sum % 11] != code[17].toUpperCase()){
row=false;
_this.toastshow = true
_this.toastTxt = "证件号码有误,校验位错误";
}
}
}
return row;
},
textareaBlur(){
var patrn= /[\u4E00-\u9FA5]|[\uFE30-\uFFA0]/gi;
let txtArry = this.fontTxt.split(/[\n\s+,+，+.+。+：+:+、+-]/g);
for(let i =0;i<txtArry.length;i++){
if(txtArry[i].trim().replace(patrn, "").length == 11){
this.basemessage.phone = txtArry[i].trim().replace(patrn, "");
}
if(txtArry[i].trim().replace(patrn, "").length >= 15){
this.basemessage.certNo = txtArry[i].trim().replace(patrn, "");
}
if(txtArry[i].trim().length<2 || !patrn.exec(txtArry[i].trim()) || txtArry[i].trim().indexOf('电话') != -1 || txtArry[i].trim().indexOf('身份') != -1){

}else {
this.basemessage.name = txtArry[i].trim();
}
}
},
getUrlParam (name) {
var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
let url = location.href;
let search = url.split('?')[1]
if (search) {
var r = search.substr(0).match(reg)
if (r !== null) return decodeURI(r[2])
return null
} else {
return null
}
}
},
mounted(){
var _this = this;
/*    getken(_this.getUserId);*/
this.hosCode =_this.$route.query.hosCode;
if(!_this.$route.query.hosCode){
this.hosCode ='420100000002';
}
this.$store.commit('updateLoadingStatus',{isLoading:true});
axios.get('http://front.wh.jinxin-fertility.com/weixin/getsigninfo?url=' + encodeURIComponent(window.location.href)
+'&hosCode=' + this.hosCode
).then(response => {
this.weixindata = response.data;
const code = _this.getUrlParam('code');
if(!_this.$route.query.code){
var appid = response.data.appId;
console.log(location.href)
var redirect_uri = encodeURIComponent(location.href);
if(code == null || code === ''){
window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + appid + "&redirect_uri=" + redirect_uri + "&response_type=code&scope=snsapi_base&state=1#wechat_redirect"
}
}else{
_this.getopenid(_this.$route.query.code)

}


wx.config({
debug: false,
timestamp: _this.weixindata.timestamp,
nonceStr: _this.weixindata.noncestr,
signature: _this.weixindata.signature,
appId: _this.weixindata.appId,
jsApiList: ['onMenuShareAppMessage','onMenuShareTimeline','hideMenuItems']
});
}).catch(function (error) {
promptMessage('提示' +error)

});
/* var uploadBtn = document.querySelector('#upload');
uploadBtn.addEventListener('change',function(){
var imgLen = this.files.length;
if(imgLen>1){
promptMessage('提示','只能选择一张图片');
return false;
}
var reader = new FileReader();
reader.readAsDataURL(this.files[0]);
reader.onload = function(e) {
let imgindex = reader.result.indexOf(',');
let imgurl = reader.result.substring(imgindex+1,reader.result.length)
_this.$store.commit('updateLoadingStatus',{isLoading:true});
axios({
method: 'post',
url: 'https://dm-51.data.aliyun.com/rest/160601/ocr/ocr_idcard.json',
data: {
"image":  imgurl,
"configure": "{\"side\":\"face\"}"
},
headers:{
Authorization:'APPCODE a98612384f8a4bec8ee691f5c17bfbb2'
}
}).then(function (response) {
if(!response.data.success){
promptMessage('提示','身份证信息读取失败，请重新上传身份证图片');
}else{
_this.toastTxt ='身份证识别成功，信息已智能填充';
_this.toastshow =true;
_this.basemessage.birthday =response.data.birth.substring(0,response.data.birth.length-4)+ '-' +response.data.birth.substring(response.data.birth.length-4,response.data.birth.length-2)+'-'+response.data.birth.substring(response.data.birth.length-2,response.data.birth.length)
_this.basemessage.certNo = response.data.num;
_this.basemessage.name = response.data.name;
if (response.data.sex == '女'){
_this.basemessage.sex = 2;
}else if (response.data.sex == '男'){
_this.basemessage.sex = 1;
}else {
_this.basemessage.sex = 9;
}

}
_this.$store.commit('updateLoadingStatus',{isLoading:false});
}).catch(function (error) {
promptMessage('提示',error);
_this.$store.commit('updateLoadingStatus',{isLoading:false});
});
};
_this.$refs.uploadref.value = null;

},false);*/
this.$nextTick(function(){
$('.inputClick').on('click',function(){
$(this).find('input').focus();
})
})
let pregistrationObj = window.localStorage.getItem('pregistrationTxt');
if(pregistrationObj !== null && pregistrationObj != 'null'){
let JSONpregistration = JSON.parse(pregistrationObj)
this.basemessage.name = JSONpregistration.name;
this.basemessage.certNo = JSONpregistration.certNo;
this.basemessage.phone = JSONpregistration.phone;
}
}
}



// WEBPACK FOOTER //
// ./src/project/pregnancyProject/pregnancyRegistration.vue